<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col cols="11" class="mx-auto pt-2 pb-0">
          <SearchBarExpanding v-if="totalCustomers > 0" @input="searchCustomers" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row
      v-if="storeCustomers.length > 0 && !loadingData"
      align="center"
      class="mx-auto"
    >
      <v-col
        cols="11"
        class="mx-auto px-0"
      >
        <v-card
          v-for="(customer) in storeCustomers"
          :key="customer.id"
          :ripple="false"
          data-testid="store-customer-card"
          rounded="xxl"
          class="my-2 solo"
          @click="showCustomerDetail(customer.id)"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                cols="11"
                align-self="center"
                class="px-6"
              >
                <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                  {{ customer.attributes.company_name }}
                </v-card-text>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                  cols="2"
                  class="px-6"
                >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('customerID') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ customer.attributes.unique_id }}
                </div>
              </v-col>
              <v-col
                cols="10"
                md="5"
                class="px-6"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('labelCustomerCompany') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ customer.attributes.company_name }}
                </div>
              </v-col>
              
              <v-col
                cols="10"
                md="5"
                class="px-6"
              >
              <div class="text-body-2 grey--text justify-left">
                  {{ $t('labelCustomerContactEmail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ customer.attributes.email }}
                </div>
              </v-col>
           
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="storeCustomers.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="storeCustomersInfo.total"
      :page-number="storeCustomersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
       <PlusButtonWithLink
      data-testid="create-customer-button"
      rounded="xl"
      :link="link"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { getStoreCustomers, searchStoreCustomers } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import Pagination from '../../components/Pagination'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import SearchBarExpanding from '../../components/SearchBarExpanding'

export default {
    components: {
        AlertMessages,
        Pagination,
        PlusButtonWithLink,
        SearchBarExpanding
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
          storeCustomers: [],
          alertType: '',
          alertMsg: '',
          alertValue:false,
          spaceId: window.$cookies.get('space_id'),
          loadingData: false,
          storeCustomersInfo: {
            currentPage: 1,
            total: 1,
          },
          size: 15,
          pageNumber: 1,
          paginationKey: '',
          userId: window.$cookies.get('id'),
          link: {title: i18n.t('createCustomerTitle'), route: '/customer/create'},
          search: null,
          totalCustomers: 0
        }
    },
    async created(){      
       if(this.$route.params.successfullyCreatedCustomer){      
            this.alertType = 'success'    
            this.alertMsg = i18n.t('newCustomerSuccessMsg')
            this.alertValue = true
        }
        this.loadingData = true
        await this.fetchStoreCustomers()
        this.loadingData = false
    },
    methods:{
        showCustomerDetail(id){
            this.$router.push({path: '/store/customer/' + id })
        },
        handlePageChange(value){
            this.storeCustomersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              this.fetchStoreCustomers()
            }else {
              this.searchCustomers(this.search)
            }
        },

        async searchCustomers(keyword){
          this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchStoreCustomers(this.spaceId,keyword,this.pageNumber, this.size)
                  if(response){
                      if(response.status == 200){
                        this.storeCustomers = response.data.data
                        if(this.storeCustomers.length == 0 && response.data.meta.page.total > 0){
                            this.pageNumber = 1
                            await this.searchCustomers(keyword)
                        }else {
                            this.storeCustomersInfo = response.data.meta.page
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },

        async resetSearch(){
          this.storeCustomersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchStoreCustomers()
          this.search = null
          this.paginationKey = Date.now()
          return
        },

        async fetchStoreCustomers(){
            try {
                const response = await getStoreCustomers(this.spaceId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.storeCustomers = response.data.data
                        if(this.storeCustomers.length == 0 && response.data.meta.page.total > 0){
                            this.pageNumber = 1
                            await this.fetchStoreCustomers()
                        }else {
                          this.storeCustomersInfo = response.data.meta.page
                          this.totalCustomers = response.data.meta.page.total
                          if(this.pageNumber == 1){
                            this.paginationKey = Date.now()
                          }
                          window.scrollTo(0,0)
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        },
    }
}
</script>
